module.exports = __webpack_public_path__ + "media/images/upload-file-d33f6fd32baafd4207f193654cef51f85f10acfe6f54285de63f965dba40ab17.svg";